import {
    faGithub,
    faLinkedin,
} from '@fortawesome/free-brands-svg-icons'
import {
    faEnvelope,
} from '@fortawesome/free-solid-svg-icons'
import {
    useState,
} from 'react'
import { ThemeProvider } from 'styled-components'


import {
    PageWrapper,
    NavigationBar,
    Link,
    HeaderText,
    ContentWrapper,
    ContactSectionWrapper,
    Portrait,
    Content,
    ContactWrapper,
    StyledLink,
    StyledIcon,
    ImageText,
    Section,
    SectionTitle,
    ProjectGrid,
    ProjectCard,
    ProjectName,
    ProjectDescription,
    TagRow,
    Tag,
    ProjectLinkButton,
    ExperienceList,
    ExperienceHeader,
    ExperienceRole,
    ExperienceMeta,
    ExperienceSummary,
} from "./style.js"
import BlurredUpImage from "../BlurredUpImage"

import DropdownMenu from "../dropdown"
import themes from "./themes"
import { projects, experience } from "./content"
import portrait from "../images/square_crop.jpg"

export const App = () => {
    const isMobile = window.innerWidth < 600
    const initialTheme = (
        isMobile
            ? themes[4]
            : themes[Math.floor((Math.random() * Object.keys(themes).length) + 1)]
    )
    const [theme, setTheme] = useState(initialTheme)

    return (
        <ThemeProvider theme={theme}>
            <PageWrapper>
                <NavigationBar>
                    <Link href="#aboutme">
                        About Me
                    </Link>
                    <Link href="#projects">
                        Projects
                    </Link>
                    <Link href="#experience">
                        Experience
                    </Link>
                    <Link href="#contactinfo">
                        Contact
                    </Link>
                    <DropdownMenu setTheme={setTheme}/>
                </NavigationBar>
                <BlurredUpImage smallImage={theme.image1Mini} largeImage={theme.image1}>
                    <HeaderText>
                        Hi I'm Marty.
                    </HeaderText>
                </BlurredUpImage>
                <ContentWrapper id="aboutme">
                    <Portrait src={portrait} />
                    <Content>
                        I'm a software engineer at Google, currently in London on the
                        Android Developer Velocity team, where I build tools that make
                        Android development faster. Before that I spent three years in
                        San Francisco building
                        <StyledLink href="https://wearos.google.com/"> Google Wallet </StyledLink>
                        for smartwatches. I graduated from Harvard in 2020 with a degree
                        in computer science and a minor in government. I enjoy
                        <StyledLink href="https://www.over-view.com/daily"> aerial photography</StyledLink>,
                        sports, politics, and building things — like
                        <StyledLink href="https://quickqtrivia.com"> QuickQ</StyledLink>,
                        a quiz-bowl-style daily trivia game.
                    </Content>
                </ContentWrapper>
                <Section id="projects">
                    <SectionTitle>Projects</SectionTitle>
                    <ProjectGrid>
                        {projects.map(project => (
                            <ProjectCard key={project.name}>
                                <ProjectName>{project.name}</ProjectName>
                                <ProjectDescription>{project.description}</ProjectDescription>
                                <TagRow>
                                    {project.tags.map(tag => (
                                        <Tag key={tag}>{tag}</Tag>
                                    ))}
                                </TagRow>
                                {
                                    project.link && (
                                        <ProjectLinkButton href={project.link}>
                                            {project.linkText}
                                        </ProjectLinkButton>
                                    )
                                }
                            </ProjectCard>
                        ))}
                    </ProjectGrid>
                </Section>
                {
                    !isMobile && (
                        <BlurredUpImage smallImage={theme.image2Mini} largeImage={theme.image2}>
                            <ImageText>
                                Try refreshing the page or choosing a theme from the drop-down at the top of the page.
                            </ImageText>
                        </BlurredUpImage>
                    )
                }
                <Section id="experience">
                    <SectionTitle>Experience</SectionTitle>
                    <ExperienceList>
                        {experience.map(job => (
                            <div key={job.role + job.dates}>
                                <ExperienceHeader>
                                    <ExperienceRole>{job.role}</ExperienceRole>
                                    <ExperienceMeta>{job.dates}</ExperienceMeta>
                                </ExperienceHeader>
                                <ExperienceMeta>
                                    {job.team} · {job.location}
                                </ExperienceMeta>
                                <ExperienceSummary>{job.summary}</ExperienceSummary>
                            </div>
                        ))}
                    </ExperienceList>
                </Section>
                <ContactSectionWrapper id="contactinfo">
                    <ContactWrapper>
                        {"GitHub: "}
                        <StyledLink href="https://github.com/mheavey18">
                            <StyledIcon icon={faGithub} className="fa-lg"/>
                        </StyledLink>
                    </ContactWrapper>

                    <ContactWrapper>
                        {"martyheavey@gmail.com: "}
                        <StyledLink href="mailto: martyheavey@gmail.com">
                            <StyledIcon icon={faEnvelope} className="fa-lg"/>
                        </StyledLink>
                    </ContactWrapper>
                    
                    <ContactWrapper>
                        {"LinkedIn: "}
                        <StyledLink href="https://www.linkedin.com/in/marty-heavey/">
                            <StyledIcon icon={faLinkedin} className="fa-lg"/>
                        </StyledLink>
                    </ContactWrapper>
                </ContactSectionWrapper>
            </PageWrapper>
        </ThemeProvider>
    )
}

export default App;
